import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Stores from '@/components/Fix'
import Person from '@/components/Person'
import AddCommondity from '@/components/page1/AddCommondity'

Vue.use(Router)

export default new Router({
  // package_update
  // model:'history',
  routes: [
    {
      path: '/', name: 'home', component: Home
    }, {
      path: '/home', name: 'Home', component: Home
    }, {
      path: '/stores', name: 'Stores', component: Stores
    }, {
      path: '/user', name: 'Person', component: Person
    }, {
      path: '/addCommondity', component: AddCommondity
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js